import { render, staticRenderFns } from "./escanear.vue?vue&type=template&id=5e32b854&scoped=true"
import script from "./escanear.vue?vue&type=script&lang=js"
export * from "./escanear.vue?vue&type=script&lang=js"
import style0 from "./escanear.vue?vue&type=style&index=0&id=5e32b854&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e32b854",
  null
  
)

export default component.exports